import api from "../../../../../../service/api";

export const uploadSapUnpaidInvoices = async (formdata) => {
    const response = await api.post("tms/sap-unpaid-invoice/upload", formdata);

    return response.data;
};

export const getSapUnpaidInvoices = async (params = {}) => {
    const response = await api.get("tms/sap-unpaid-invoice/index", params)

    return response
}

export const getSapUnpaidInvoiceCompanies = async () => {
    const response = await api.get('tms/sap-unpaid-invoice/companies')

    return response
}

export const generateSoa = async (payload = {}) => {
    console.log('payload', payload)
    const response = await api.postPdf('tms/sap-unpaid-invoice/generate-soa',payload)

    console.log('response', response)
    return response
}
